module.exports = __webpack_public_path__ + "img/icon-play-video.c6dcb430.svg";